import { IUserAutocomplete } from 'auth/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getManyAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IUserAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/admin/user/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IUserAutocomplete>(data.users, data.total_count);
};
